import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import About from './About';

const introTabs = [
  { key: 'news', label: '최신소식' },
  { key: 'faq', label: '자주 묻는 질문' },
  { key: 'about', label: '올받음 소개' },
  { key: 'adjusters', label: '손사 소개' },
];

const AboutLayout = () => {
  return (
    <>
      <Outer>
        <Container>
          <Left>
            <Title>보험회사와 아무런 이해관계가 없는 독립손해사정법인입니다</Title>
            <Subtitle>올받음이 소비자 편에서 도와드리겠습니다</Subtitle>
          </Left>
        </Container>
      </Outer>

      <SideOuter>
        <SideContainer>
          <SideWrapper>
            <TabList>
              {introTabs.map((tab) => (
                <StyledTab key={tab.key} to={`/intro/${tab.key}`}>
                  {tab.label}
                </StyledTab>
              ))}
            </TabList>
          </SideWrapper>
          <ContentArea>
            <About />
          </ContentArea>
        </SideContainer>
      </SideOuter>
    </>
  );
};

export default AboutLayout;

// ---------------- styled-components ----------------

const Outer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 80px 0 0 0;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 1230px;
  height: 225px;
  padding: 0 0 80px 0;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 1px solid #bdbdbd;
`;

const Left = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

const Title = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: var(--gray-ui_gray02, #252525);
`;

const Subtitle = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: var(--gray-ui_gray02, #252525);
`;

const SideOuter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
`;

const SideContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1230px;
  gap: 40px;
`;

const SideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 30%;
  padding-top: 50px;
  flex-shrink: 0;
`;

const TabList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: start;
`;

const StyledTab = styled(NavLink)`
  padding: 16px 12px;
  font-size: 20px;
  font-weight: 500;
  color: var(--gray-ui_gray04, #6f6f6f);
  text-decoration: none;

  &.active {
    color: #0b46dd;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  padding-top: 50px;
`;
